import { auth } from "@/config/firebase";
import { setCurrentUser, checkEmailStatus } from "@/utils/helpers";
import { log } from "@/utils/logger";
import { User } from "firebase/auth";
import { useEffect, useRef } from "react";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import router from "@/router";

const useLoadApp = () => {
    const logout = useUser(state => state.logout);
    const setGlobalLoading = useUser(state => state.setGlobalLoading);
    const setIsAppLoaded = useUser(state => state.setIsAppLoaded);
    const unsubscribe = useRef<() => void>();
    const authRoutes = ["/sign-in", "/reset-password", "/sign-up"];

    const path = router.state.location.pathname;

    const onAuthStateChanged = async (user: User | null) => {
        try {
            setGlobalLoading(true);
            unsubscribe.current?.();

            if (!user && !authRoutes.includes(path)) {
                sessionStorage.setItem("savedRoute", path);
            }
            if (!user && authRoutes.includes(path)) {
                return setIsAppLoaded(true);
            }

            if (!user) clearApp();
            if (!user) return router.navigate("/sign-in");

            await checkEmailStatus(user);
            await setCurrentUser(user);
        } catch (e) {
            log.error(e, "onAuthStateChanged");
        } finally {
            setGlobalLoading(false);
            setIsAppLoaded(true);
        }
    };

    const clearApp = () => {
        const hasStorage = localStorage.length;
        if (hasStorage) {
            storage.clear(), logout();
        }
    };

    useEffect(() => {
        if (path === "/email-actions") {
            setIsAppLoaded(true);
            return;
        }

        setGlobalLoading(true);
        const sub = auth.onAuthStateChanged(onAuthStateChanged);
        unsubscribe.current = sub;
    }, []);
};

export default useLoadApp;
